// modules/land-and-sale/LandSearch.js
import React            from 'react';
import $                from 'jquery';
import PageLoading      from '../PageLoading';

import LandSearchBar        from './elements/LandSearchBar';
import LandSearchSorting    from '../common/LandSearchSorting';
import LandSearchList       from './elements/LandSearchList';
import LandSearchGrid       from './elements/LandSearchGrid';

import '../App.css';

let sources = require('../config.json');

class LandSearch extends React.Component {
    constructor(props) {
        super(props);
		var d = new Date();
        this.landsearch_url = sources.landsearch + "?ts=" + d.getTime();
        this.state = {
			data: {},
			lots: [],
			lotsFiltered: [],
			lotsSorted: [],
			view: 'list',
			sort: {}
		};

        this.onSearchUpdate = this.onSearchUpdate.bind(this);
        this.onSearchReset = this.onSearchReset.bind(this);
        this.onSortUpdate = this.onSortUpdate.bind(this);
        this.onViewSwitch = this.onViewSwitch.bind(this);
        this.viewSwitcher = this.viewSwitcher.bind(this);
        this.filterByFrontage = this.filterByFrontage.bind(this);
        this.filterByArea = this.filterByArea.bind(this);
        this.filterByAvailable = this.filterByAvailable.bind(this);
    }

    componentDidMount() {
	    window.scrollTo(0,0);
        let landSearch = $.ajax({url: this.landsearch_url,dataType:'json'});
        $.when(landSearch).done(function(data) {
            let newState = Object.assign(this.state, {
                data: data,
                lots: this.filterByAvailable(data.lots),
                lotsFiltered: this.filterByAvailable(data.lots),
                lotsSorted: this.filterByAvailable(data.lots)
            });
            this.setState(newState);
        }.bind(this));
    }

    onSearchUpdate(frontage, land) {
        $('.btn__filter-search').addClass('searching-active');

        let lotsFiltered = this.state.lots;
        if(frontage !== null) { lotsFiltered = this.filterByFrontage(frontage, lotsFiltered); }
        if(land !== null) { lotsFiltered = this.filterByArea(land, lotsFiltered); }

        if(this.state.sort !== null) {
            let newState = Object.assign(this.state, {
                lotsFiltered: lotsFiltered
            });
            this.setState(newState);
            this.onSortUpdate(this.state.sort.type, this.state.sort.direction);
        } else {
            let newState = Object.assign(this.state, {
                lotsFiltered: lotsFiltered,
                lotsSorted: lotsFiltered
            });
            this.setState(newState);
        }
        setTimeout(() => { $('.btn__filter-search').removeClass('searching-active'); }, 1000);
    }

    filterByFrontage(frontage, lots) {
        return lots.reduce(function (accum, lot) {
            if (lot.frontage >= frontage.start && lot.frontage <= frontage.end)
                accum.push(lot);
            return accum;
        }, []);
    }

    filterByArea(area, lots) {
        return lots.reduce(function (accum, lot) {
            if (lot.area >= area.start && lot.area <= area.end)
                accum.push(lot);
            return accum;
        }, []);
    }

    filterByAvailable(lots) {
        return lots.reduce(function (accum, lot) {
            if (parseInt(lot.status,10) !== 2)
                accum.push(lot);
            return accum;
        }, []);
    }

    onSearchReset() {
        if(this.state.sort !== null) {
            let newState = Object.assign(this.state, {
                lotsFiltered: this.state.lots
            });
            this.setState(newState);
            this.onSortUpdate(this.state.sort.type, this.state.sort.direction);
        } else {
            let newState = Object.assign(this.state, {
                lotsFiltered: this.state.lots,
                lotsSorted: this.state.lots
            });
            this.setState(newState);
        }
    }

    onViewSwitch(view) {
        if(view !== this.state.view) {
            let newState = Object.assign(this.state, {
                view: view
            });
            this.setState(newState);
        }
    }

    onSortUpdate(type, direction) {

        let tempArr = this.state.lotsFiltered;

        var notIrregularLots = tempArr.reduce(function (accum, lot) {
            if (lot.type !== 'Irregular Lot' && lot.type !== 'Corner Lot')
                accum.push(lot);
            return accum;
        }, []);

        var irregularLots = tempArr.reduce(function (accum, lot) {
            if (lot.type === 'Irregular Lot' || lot.type === 'Corner Lot')
                accum.push(lot);
            return accum;
        }, []);
        switch(direction) {

            case 'asc':
                notIrregularLots.sort((a, b) => {
                    return a[type] - b[type];
                });
                if(type === 'frontage') {
					irregularLots.sort((a, b) => {
						return b[type] - a[type];
					});
				}else{
					irregularLots.sort((a, b) => {
						return a[type] - b[type];
					});
				}
                break;
            case 'dsc':
                notIrregularLots.sort((a, b) => {
                    return b[type] - a[type];
                });
				irregularLots.sort((a, b) => {
					return b[type] - a[type];
				});
				break;
            default:
        }

        let newState = Object.assign(this.state, {
            lotsSorted: notIrregularLots.concat(irregularLots),
            sort: {
                type: type,
                direction: direction
            }
        });
        this.setState(newState);
    }

    viewSwitcher() {
        if(this.state.lotsSorted.length === 0) {
            return ( <p className="m-b-0 p-a-1 release-title tc">No search results found matching your criteria.</p> )
        }
        if (this.state.view === 'list') {
            return ( <LandSearchList data={this.state.lotsSorted}/> )
        }
        if (this.state.view === 'grid') {
            return ( <LandSearchGrid data={this.state.lotsSorted}/> )
        }
    }

    render() {
        if (typeof this.state.data.lots !== "undefined") {
            return (
                <div className="App">
                    <section className="section p-t-2">
                        <div className="container">
                            <div className="section__content tc">
                                <LandSearchBar onSearchClick={this.onSearchUpdate} onResetClick={this.onSearchReset} search={this.props.location.query} divClass="filter release__filter js-accordion open"/>
                            </div>
                        </div>
                    </section>

                    <section className="section p-h-1 p-h-3-lg section-bg-white land-filter-section">
                        <div className="container">
                            <div className="cf m-b-3-lg m-b-1">
                                <div className="w-100">
                                    <LandSearchSorting onSort={this.onSortUpdate} onSwitch={this.onViewSwitch} view={this.state.view} search={this.props.location.query}/>
                                    {this.viewSwitcher()}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            );
        } else {
            return (
                <PageLoading>Land Search</PageLoading>
            )
        }
    }

}

export default LandSearch;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/LandSearch.js
 **/